export {
    STORE_TYPE_BITRIX,
    STORE_TYPE_KIT,
    STORE_TYPE_LITE,
    STORE_TYPE_REMOTE_ORM,
    STORE_TYPE_YCP,
} from '../storeInfo';

/** Для консистентности, чтобы не было отличий в написании в разных местах */
export const YANDEX_KIT_BRAND_NAME = 'Яндекс\u00A0KIT';

/** Для консистентности, чтобы не было отличий в написании в разных местах */
export const YANDEX_YCP_BRAND_NAME = 'YCP';

/** При переименовании важно поменять во всех местах использования */
export const COMPARE_PRODUCTS_SETTING = 'Сопоставлять по';

/** Условия использования */
export const LEGAL_TERMS_OF_USE_URL = 'https://yandex.ru/legal/merchantsiteconstruct_termsofuse/ru/';

export const LEGAL_TERMS_OF_USE_URL_CHECKOUT = 'https://yandex.ru/legal/ycp_termsofuse/ru/';

/** Политика конфиденциальности */
export const LEGAL_CONFIDENTIAL_URL = 'https://yandex.ru/legal/confidential/ru/';

/** Справка Мерчант Центра */
export const MERCHANTS_SUPPORT_URL = 'https://yandex.ru/support/merchants/ru/buy-button';

/** Ссылка на справку о проверке названия магазина (форма регистрации Lite-магазина) */
export const MERCHANTS_STORE_NAME_CHECK_HELP_URL = 'https://yandex.ru/support/merchants/ru/merchant-name#change-name';

/** Ссылка на справку о требованиях к интернет-магазинам (форма регистрации Lite-магазина) */
export const MERCHANTS_STORES_REQUIREMENTS_HELP_URL = 'https://yandex.ru/support/merchants/ru/requirement';

/** Требования к названию магазина в Мерчант Центре */
export const MERCHANTS_SHOP_NAME_HELP_URL = 'https://yandex.ru/support/merchants/ru/merchant-name';

/** Алиса AI */
export const ALICE_LOGO_PROMPT_URL = 'https://alice.yandex.ru/';

/** Справка */
export const KIT_SUPPORT_URL = 'https://yandex.ru/support/kit/ru/';

/** Справка с UTM-параметрами */
export const KIT_SUPPORT_URL_WITH_UTM = `${KIT_SUPPORT_URL}?utm_source=lk&utm_medium=spravka&utm_campaign=main`;

/** Справка для KIT Lite магазина */
export const KIT_LITE_SUPPORT_URL =
    'https://yandex.ru/support/kit/ru/?utm_source=lk&utm_medium=free&utm_content=inv-own__snd-ycpseller__fmt-sidebar__ecom&utm_campaign=dept-mrkt__svc-kit__aud-b2b__msg-answers__faq_kit_ycpseller';

/** О ЕКОМ-сервисах */
export const ABOUT_ECOM_SERVICES_URL = 'https://b2b.yandex.ru/adv/instrumenty-prodvizheniya-dlya-ecommerce';

/** Форма обратной связи */
export const FEEDBACK_FORM_URL = 'https://forms.yandex.ru/surveys/13771493.2a32083eaf2a603f8f83f67c51384c24a808e039/';

/** Страница с настройками персональных данных в Яндекс ID */
export const YANDEX_ID_PERSONAL_URL = 'https://id.yandex.ru/personal';

/** Внешний лендинг с программами */
export const YANDEX_KIT_LANDING_URL = 'https://kit.yandex.ru';

/** Ссылка на лендинг про YCP */
export const YANDEX_YCP_LANDING_URL = 'https://merchants.yandex.ru/ycp';

/** Ссылка на документацию Мерчант Центра "Что такое YCP" */
export const YANDEX_YCP_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/';

/** Ссылка на документацию Мерчант Центра "Кнопка Купить в 1 клик" */
export const YANDEX_BUY_BUTTON_HELP_URL = 'https://yandex.ru/support/merchants/ru/buy-button#plug';

/** Ссылка на документацию Мерчант Центра, где показано, где найти API-ключ в 1С-Битрикс модуле */
export const HOW_TO_FIND_BITRIX_API_KEY_HELP_URL =
    'https://yandex.ru/support/merchants/ru/buy-button#generate-access-token';

/** Ссылка на документацию Мерчант Центра, где показано, куда передавать API-ключ в настройках 1С-Битрикс модуля */
export const WHERE_TO_PUT_API_KEY_IN_BITRIX_HELP_URL =
    'https://yandex.ru/support/merchants/ru/buy-button#where-to-put-api-token';

/** Ссылки на документацию API-методов YCP */
export const YCP_WAREHOUSES_GET_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/warehouses-get';
export const YCP_CHECKOUT_BASKET_CHECK_DOC_URL =
    'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkoutbasketcheck-post';
export const YCP_CHECKOUT_CREATE_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkout-post';
export const YCP_CHECKOUT_PLACED_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkoutplaced-post';
export const YCP_CHECKOUT_CANCEL_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkoutcancel-post';
export const YCP_CHECKOUT_ORDER_CANCEL_DOC_URL =
    'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/ordercancel-post';
export const YCP_DELIVERY_PICKUP_POINTS_GET_DOC_URL =
    'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkoutdeliverypickup_points-get';
export const YCP_DELIVERY_OPTIONS_CALC_DOC_URL =
    'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/checkoutdeliveryoptions-post';
export const YCP_DELIVERY_ORDER_STATUS_GET_DOC_URL = 'https://yandex.ru/support/merchants-ru-ycp/ru/openapi/order-get';

export const MERCHANTS_FEED_HOW_TO_URL = 'https://yandex.ru/support/merchants/ru/connect/form-feed';
export const MERCHANTS_FEED_ELEMENTS_DOC_URL = 'https://yandex.ru/support/merchants/ru/export/vendor-model#list';
export const MERCHANTS_BUY_BUTTON_ON_WEBSITE_DOC_URL = 'https://yandex.ru/support/merchants/ru/buy-button-site';

/** Домены B2B платформы */
export const B2B_DOMAIN_PRODUCTION = 'b2b.kit.yandex.ru';
export const B2B_DOMAIN_TEST = 'test.b2b.kit.yandex.ru';
export const B2B_DOMAIN_DEV = 'dev.b2b.kit.yandex.ru';
export const B2B_DOMAIN_SANDBOX = 'sandbox.b2b.kit.yandex.ru';
export const B2B_DOMAIN_LOCAL = 'yastore.yandex.ru';
export const B2B_DOMAIN_YASTORE = 'b2b.yastore.yandex.ru';
export const B2B_DOMAIN_YCP_DEV = 'dev.checkout.merchants.yandex.ru';
export const B2B_DOMAIN_YCP_TEST = 'test.checkout.merchants.yandex.ru';
export const B2B_DOMAIN_YCP_PRODUCTION = 'checkout.merchants.yandex.ru';
export const B2B_DOMAIN_YCP_SANDBOX = 'sandbox.checkout.merchants.yandex.ru';

/** URL B2B платформы (local) */
export const B2B_URL_LOCAL = `https://${B2B_DOMAIN_LOCAL}:9000`;

/** URL Ecom */
export const ECOM_URL =
    'https://yandex.ru/adv/news?utm_source=lk&utm_medium=free&utm_content=inv-own__snd-kit__fmt-sidebar__ecom&utm_campaign=dept-mrkt__svc-kit__aud-b2b__msg-news__0426_lk_adv_ecom&tag=ecom';

/** Ссылка приглашения в Telegram канал Ecom */
export const ECOM_TELEGRAM_URL = 'https://t.me/ya_ecom';

/** Ссылка приглашения в Telegram канал KIT */
export const KIT_TELEGRAM_URL = 'https://t.me/+JRLwTLiZJ-83NGQy';

/** Счетчик Яндекс Товары для логирования событий в кабинете внешнего чекаута */
export const MERCHANTS_METRIKA_COUNTER_ID = 97698344;
